import ExitPopupWebMobileComponent from '../../../../../pages/vip/features/exit-popup-web-mobile/exit-popup-web-mobile';

export default ExitPopupWebMobileComponent;
